import apiInstance from '../../../../backend-api.setup'
import { ApiPathConfig } from '../../../../../config/ApiPathConfig'

const PostDataFromSelectedInfluencer = (user_ids: string[], id_ean: string) => {
  return apiInstance.post(ApiPathConfig.EXPORT_DATA_CHRONIQUEUR(id_ean), {
    user_ids,
  })
}

export default PostDataFromSelectedInfluencer
